// @flow
import { START_SYNC, COMPLETE_SYNC, SYNC_ERROR } from './types';
import type { Action } from './types';

export const startSync = (): Action => ({
	type: START_SYNC,
});

export const completeSync = (): Action => ({
	type: COMPLETE_SYNC,
});


export const errorSync = (error: Error): Action => ({
	type: SYNC_ERROR,
	payload: error
});
